@if (chat) {
  <app-base-modal
    [title]="getTitle()"
  >
    <div class="container">
      @if (isLoading) {
        <app-loader/>
      }
      <app-telegram-bloggers
        [chats]="chats"
        [selectedChat]="chat"
        [isVisibleBloggers]="isVisibleBloggers"
        (handleSelectChat)="handleSelectChat($event)"
        (toggleBlogger)="toggleBlogger()"
      />
      <app-telegram-chat-window
        [selectedChat]="chat"
        [messages]="messages"
        [recordCalendarId]="dialogData.recordCalendarId"
        [isModal]="true"
        (sendMessage)="sendMessage($event)"
      />
    </div>
  </app-base-modal>
}
